import { createFileRoute, redirect } from '@tanstack/react-router';
import { TRADE_REPORTING_BLUE_SHEET_BASE_PATH } from '../../../../../../../../features/trade-reporting/blue-sheet/trade-reporting-blue-sheet-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/')({
  beforeLoad: () => {
    throw redirect({ to: TRADE_REPORTING_BLUE_SHEET_BASE_PATH });
  },
  preload: false,
});
